import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-waitron-page-loader',
  standalone: false,
  templateUrl: './waitron-page-loader.component.html',
  styleUrl: './waitron-page-loader.component.scss',
})
export class WaitronPageLoaderComponent {
  @Input() show = false;
  @Input() message = 'Loading...';
  @Input() fullscreen = true;
  @Input() overlay = true;
}
